exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"_variables.scss","sourceRoot":""}]);

// exports
exports.locals = {
	"fontStack": "\"Open Sans\",\"Lucida Grande\",Lucida,\"Lucida Sans Unicode\",sans-serif",
	"containerWidthMain": "960",
	"heightDesktopHeader": "139px",
	"minicartWidth": "350px",
	"minicartTipRightOffsetDesktop": "15px",
	"minicartTipSide": "5px"
};